module.exports = __webpack_public_path__ + "static/media/design.29a04ce7.png";